import React from 'react';

import type { Props } from '@travel/traveler-core/components/CouponSearchError';
import CouponSearchErrorCore from '@travel/traveler-core/components/CouponSearchError';

function CouponSearchError(props: Props) {
  if (!props.message) {
    return null;
  }

  return <CouponSearchErrorCore {...props} />;
}

export default CouponSearchError;
